import { render, staticRenderFns } from "./Pro.vue?vue&type=template&id=ec5d6fb6"
import script from "./Pro.vue?vue&type=script&lang=js"
export * from "./Pro.vue?vue&type=script&lang=js"
import style0 from "./Pro.vue?vue&type=style&index=0&id=ec5d6fb6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports